/* CUSTOM voucher-picker.js — gefuehrter Gutschein-Kauf + animierte Buehne.
 * Physisch: gestapelte PNG-Layer (ruckelfreies Cross-Fade), Klick schliesst/oeffnet, Handschrift-Wert.
 * Digital: HTML-Nachbau (Betrag/Gruss/Code dynamisch), ruhiger Matrix-Code, Ampel-Klick schliesst kurz.
 */
(function () {
  if (customElements.get('voucher-picker')) return;

  const FORMAT_NOTE = {
    'Digital': 'Delivered by email — ready to print or forward.',
    'By post': 'Printed in the studio, shipped by post · 2–4 business days.',
  };
  const CODE_CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ0123456789';
  const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  class VoucherPicker extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-voucher-variants]');
      this.variants = json ? JSON.parse(json.textContent) : [];

      this.floatEl = this.querySelector('[data-voucher-float]');
      this.physEl = this.querySelector('[data-physical]');
      this.baseEl = this.querySelector('[data-base]');
      this.ovOpen = this.querySelector('[data-ov-open]');
      this.ovClosed = this.querySelector('[data-ov-closed]');
      this.urls = this.physEl ? this.physEl.dataset : {};
      ['cardsGift', 'cardsWorkshop', 'envOpen', 'envClosed', 'underlay'].forEach((k) => { if (this.urls[k]) { const i = new Image(); i.src = this.urls[k]; } });
      this.stageEl = this.querySelector('[data-voucher-stage]');
      this.lightsEl = this.querySelector('[data-lights]');
      this.handwritingEl = this.querySelector('[data-voucher-handwriting]');
      this.greetingEl = this.querySelector('[data-greeting]');
      this.amountEl = this.querySelector('[data-amount]');
      this.expiryEl = this.querySelector('[data-expiry]');
      this.matrixEl = this.querySelector('[data-matrix]');
      this.balanceEl = this.querySelector('[data-balance]');
      this.digitalEl = this.querySelector('[data-digital]');
      this.mailToEl = this.querySelector('[data-mail-to]');

      this.giftGroup = this.querySelector('.voucher-picker__gift');
      this.giftToggle = this.querySelector('[data-gift-toggle]');
      this.giftFields = this.querySelector('[data-gift-fields]');
      this.giftTo = this.querySelector('[data-gift-to]');
      this.giftFrom = this.querySelector('[data-gift-from]');
      this.giftMessage = this.querySelector('[data-gift-message]');
      this.giftEmail = this.querySelector('[data-gift-email]');
      this.emailField = this.querySelector('[data-email-field]');
      this.propName = this.querySelector('[data-prop-name]');
      this.propEmail = this.querySelector('[data-prop-email]');
      this.propMessage = this.querySelector('[data-prop-message]');
      this.propGiftFlag = this.querySelector('[data-prop-giftflag]');

      this.buyId = this.querySelector('[data-buy-id]');
      this.buyBtn = this.querySelector('[data-buy]');
      this.buyLabel = this.querySelector('[data-buy-label]');
      this.formatNote = this.querySelector('[data-format-note]');
      this.giftWrap = this.querySelector('[data-amount-gift]');
      this.workshopWrap = this.querySelector('[data-amount-workshop]');
      this.formatsWrap = this.querySelector('[data-formats]');

      this.state = { value: null, euros: null, workshop: false, format: 'By post', phase: 'open', busy: false };
      this.matrixTimer = null;

      this.setExpiry();
      this.renderAmounts();
      this.renderFormats();

      if (this.stageEl) {
        this.stageEl.addEventListener('click', () => this.onStageClick());
        this.stageEl.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.onStageClick(); } });
      }
      const activate = (el, fn) => {
        if (!el) return;
        el.addEventListener('click', fn);
        el.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fn(e); } });
      };
      // CUSTOM Click-Routing pro Ampel: Rot = close, Gelb = Genie-Minimize
      if (this.lightsEl) {
        this.lightsEl.addEventListener('click', (e) => {
          e.stopPropagation();
          const dot = e.target.closest('.voucher-digital__dot');
          if (dot && dot.classList.contains('voucher-digital__dot--y')) this.windowGenie();
          else this.windowClose();
        });
        this.lightsEl.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.windowClose(); }
        });
      }
      activate(this.balanceEl, () => {
        if (!this.digitalEl) return;
        this.digitalEl.classList.add('is-404');
        clearTimeout(this._balTimer);
        this._balTimer = setTimeout(() => this.digitalEl.classList.remove('is-404'), 1800);
      });
      if (this.giftToggle) this.giftToggle.addEventListener('change', () => this.onGiftToggle());
      [this.giftTo, this.giftFrom, this.giftMessage, this.giftEmail].forEach((el) => {
        if (el) el.addEventListener('input', () => { this.updateGreeting(); this.updateMail(); this.updateProps(); this.refreshBuy(); this.equalizeHeights(); });
      });

      this.update();

      // CUSTOM Höhen-Angleich: physisch (Querformat-Bild) ist die Referenz; die digitale
      // Karte (Hochformat) wird per zoom exakt auf dieselbe Höhe gebracht. Beide liegen im
      // selben Grid-Cell → Container = physische Höhe, kein Sprung beim Variantenwechsel.
      if (window.ResizeObserver && this.physEl) {
        this._ro = new ResizeObserver(() => this.equalizeHeights());
        this._ro.observe(this.physEl);
      }
      this.equalizeHeights();
    }

    equalizeHeights() {
      if (!this.physEl || !this.digitalEl) return;
      this.digitalEl.style.zoom = '';
      const pH = this.physEl.getBoundingClientRect().height;
      const dH = this.digitalEl.getBoundingClientRect().height;
      if (!pH || !dH) return;
      this.digitalEl.style.zoom = (pH / dH).toFixed(4);
    }

    setExpiry() {
      if (!this.expiryEl) return;
      const d = new Date(); d.setFullYear(d.getFullYear() + 3);
      this.expiryEl.textContent = `Expires ${MONTHS[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
    }

    uniqueByValue(list) {
      const seen = new Set(); const out = [];
      list.forEach((v) => { if (!seen.has(v.value)) { seen.add(v.value); out.push(v); } });
      return out.sort((a, b) => a.euros - b.euros);
    }
    workshopLabel(value) {
      if (/evening/i.test(value)) return '1-Session Evening';
      if (/workshop/i.test(value)) return '3-Session Workshop';
      return '';
    }

    renderAmounts() {
      const gift = this.uniqueByValue(this.variants.filter((v) => !v.workshop));
      const workshop = this.uniqueByValue(this.variants.filter((v) => v.workshop));
      gift.forEach((v) => this.giftWrap.appendChild(this.tile(v, `${v.euros}`, 'EUR')));
      workshop.forEach((v) => this.workshopWrap.appendChild(this.tile(v, `${v.euros} EUR`, this.workshopLabel(v.value))));
    }
    tile(v, main, sub) {
      const b = document.createElement('button'); b.type = 'button';
      b.className = 'voucher-picker__tile'; b.dataset.value = v.value;
      b.innerHTML = `<span class="voucher-picker__tile-main">${main}</span><span class="voucher-picker__tile-sub">${sub}</span>`;
      b.addEventListener('click', () => this.selectValue(v));
      return b;
    }
    rowTile(v, val, hint) {
      const b = document.createElement('button'); b.type = 'button';
      b.className = 'voucher-picker__tile voucher-picker__tile--row'; b.dataset.value = v.value;
      b.innerHTML = `<span class="voucher-picker__tile-val">${val}</span><span class="voucher-picker__tile-hint">${hint}</span>`;
      b.addEventListener('click', () => this.selectValue(v));
      return b;
    }
    renderFormats() {
      const formats = [];
      this.variants.forEach((v) => { if (!formats.includes(v.format)) formats.push(v.format); });
      formats.forEach((f) => {
        const b = document.createElement('button'); b.type = 'button';
        b.className = 'voucher-picker__pill'; b.dataset.format = f; b.textContent = f;
        if (f === this.state.format) b.classList.add('is-active');
        b.addEventListener('click', () => this.selectFormat(f));
        this.formatsWrap.appendChild(b);
      });
    }

    selectValue(v) {
      this.state.value = v.value; this.state.euros = v.euros; this.state.workshop = v.workshop;
      this.querySelectorAll('.voucher-picker__tile').forEach((t) => t.classList.toggle('is-active', t.dataset.value === v.value));
      this.state.phase = 'open';
      this.update();
    }
    selectFormat(f) {
      this.state.format = f;
      this.querySelectorAll('.voucher-picker__pill').forEach((p) => p.classList.toggle('is-active', p.dataset.format === f));
      this.state.phase = 'open';
      this.update();
    }

    isPhysical() { return this.state.format === 'By post'; }
    baseForState() {
      if (this.state.phase === 'closed') return this.urls.cardsGift; // bei Zu kein Flyer
      return this.state.workshop ? this.urls.cardsWorkshop : this.urls.cardsGift;
    }

    onGiftToggle() {
      const on = this.giftToggle.checked;
      if (this.giftFields) this.giftFields.classList.toggle('is-open', on);
      this.updateEmailField();
      this.updateGreeting(); this.updateMail(); this.updateProps(); this.refreshBuy();
      if (on && !this.isPhysical() && this.digitalEl) {
        this.digitalEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    updateEmailField() {
      if (!this.emailField) return;
      // E-Mail nur bei digitalem Geschenk noetig (Versand an Empfaenger)
      this.emailField.hidden = !(this.giftToggle && this.giftToggle.checked && !this.isPhysical());
    }
    esc(s) { const d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
    updateGreeting() {
      if (!this.greetingEl) return;
      const on = this.giftToggle && this.giftToggle.checked;
      const to = this.giftTo ? this.giftTo.value.trim() : '';
      const from = this.giftFrom ? this.giftFrom.value.trim() : '';
      const msg = this.giftMessage ? this.giftMessage.value.trim() : '';
      let html = '';
      if (on && to) {
        html = `Hi ${this.esc(to)}, you’ve received a voucher` + (from ? ` from ${this.esc(from)}` : '') + '.';
        if (msg) html += `<span class="voucher-digital__msg">„${this.esc(msg).replace(/\n/g, '<br>')}“</span>`;
      }
      this.greetingEl.innerHTML = html;
    }
    updateMail() {
      if (!this.mailToEl) return;
      const on = this.giftToggle && this.giftToggle.checked && !this.isPhysical();
      const name = this.giftTo ? this.giftTo.value.trim() : '';
      const email = this.giftEmail ? this.giftEmail.value.trim() : '';
      let to = 'you';
      if (on) {
        if (name && email) to = `${name} <${email}>`;
        else if (email) to = email;
        else if (name) to = name;
        else to = 'recipient';
      }
      this.mailToEl.textContent = to;
    }
    setProp(input, val) { if (!input) return; if (val) { input.disabled = false; input.value = val; } else { input.disabled = true; input.value = ''; } }
    /* Native Shopify-Gift-Card-Properties: nur bei digitalem Geschenk */
    updateProps() {
      const on = this.giftToggle && this.giftToggle.checked && !this.isPhysical();
      this.setProp(this.propName, on && this.giftTo ? this.giftTo.value.trim() : '');
      this.setProp(this.propEmail, on && this.giftEmail ? this.giftEmail.value.trim() : '');
      let msg = '';
      if (on) {
        const m = this.giftMessage ? this.giftMessage.value.trim() : '';
        const f = this.giftFrom ? this.giftFrom.value.trim() : '';
        msg = m;
        if (f) msg = (m ? m + '\n' : '') + '— ' + f;
      }
      this.setProp(this.propMessage, msg);
      if (this.propGiftFlag) {
        this.propGiftFlag.disabled = !on;
        if (on) this.propGiftFlag.value = 'true';
      }
    }

    /* Ruhiger Matrix-Code: nur ein paar Zeichen flackern langsam */
    randCode() {
      let groups = [];
      for (let g = 0; g < 4; g++) { let s = ''; for (let i = 0; i < 4; i++) s += CODE_CHARS[Math.floor(Math.random() * CODE_CHARS.length)]; groups.push(s); }
      return groups.join(' ');
    }
    startMatrix() {
      if (this.matrixTimer || !this.matrixEl) return;
      this.codeArr = this.randCode().split('');
      this.matrixEl.textContent = this.codeArr.join('');
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.matrixTimer = setInterval(() => {
        for (let k = 0; k < 2; k++) {
          let pos; do { pos = Math.floor(Math.random() * this.codeArr.length); } while (this.codeArr[pos] === ' ');
          this.codeArr[pos] = CODE_CHARS[Math.floor(Math.random() * CODE_CHARS.length)];
        }
        this.matrixEl.textContent = this.codeArr.join('');
      }, 240);
    }
    stopMatrix() { if (this.matrixTimer) { clearInterval(this.matrixTimer); this.matrixTimer = null; } }

    onStageClick() { if (this.isPhysical()) this.toggleEnvelope(); }

    toggleEnvelope() {
      if (this.state.busy) return;
      this.state.busy = true;
      this.state.phase = this.state.phase === 'open' ? 'closed' : 'open';
      this.physEl.classList.toggle('is-closed', this.state.phase === 'closed');
      this.baseEl.src = this.baseForState();
      setTimeout(() => { this.state.busy = false; }, 360);
    }

    windowClose() {
      if (this.state.busy || this.isPhysical()) return;
      this.state.busy = true;
      this.floatEl.classList.add('is-window-closing');
      setTimeout(() => { this.floatEl.classList.remove('is-window-closing'); this.state.busy = false; }, 380);
    }

    windowGenie() {
      if (this.state.busy || this.isPhysical()) return;
      this.state.busy = true;
      this.floatEl.classList.add('is-window-genie');
      setTimeout(() => { this.floatEl.classList.remove('is-window-genie'); this.state.busy = false; }, 620);
    }

    update() {
      const physical = this.isPhysical();
      this.floatEl.classList.toggle('is-digital', !physical);
      this.floatEl.classList.toggle('is-physical', physical);

      // Geschenk-Option nur bei digitalem Gutschein
      if (this.giftGroup) {
        this.giftGroup.hidden = physical;
        if (physical && this.giftToggle && this.giftToggle.checked) {
          this.giftToggle.checked = false;
          if (this.giftFields) this.giftFields.classList.remove('is-open');
        }
      }

      if (physical) {
        this.physEl.classList.toggle('is-closed', this.state.phase === 'closed');
        this.baseEl.src = this.baseForState();
        if (this.handwritingEl) {
          this.handwritingEl.textContent = this.state.euros != null ? this.state.euros : '';
          this.handwritingEl.classList.toggle('is-visible', !!this.state.value);
        }
        this.stopMatrix();
      } else {
        if (this.amountEl) this.amountEl.textContent = this.state.euros != null ? `${this.state.euros} EUR` : '';
        this.updateGreeting();
        this.updateMail();
        this.startMatrix();
      }

      if (this.formatNote) this.formatNote.textContent = FORMAT_NOTE[this.state.format] || '';

      this.updateEmailField();
      this.updateProps();
      this.refreshBuy();
      this.equalizeHeights();
    }

    /* Geschenk an Dritte: Absender Pflicht, bei digital zusaetzlich Empfaenger-Mail */
    giftValid() {
      if (!this.giftToggle || !this.giftToggle.checked) return true;
      const from = this.giftFrom ? this.giftFrom.value.trim() : '';
      if (!from) return false;
      if (!this.isPhysical()) {
        const email = this.giftEmail ? this.giftEmail.value.trim() : '';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return false;
      }
      return true;
    }

    refreshBuy() {
      const match = this.variants.find((v) => v.format === this.state.format && v.value === this.state.value);
      const giftOk = this.giftValid();
      if (match && match.available && giftOk) {
        this.buyId.value = match.id; this.buyBtn.disabled = false;
        this.buyLabel.textContent = `Buy voucher · ${this.state.euros} EUR`;
      } else {
        this.buyId.value = ''; this.buyBtn.disabled = true;
        if (!this.state.value) this.buyLabel.textContent = 'Choose an amount';
        else if (match && match.available && !giftOk) this.buyLabel.textContent = 'Add recipient details';
        else this.buyLabel.textContent = 'Unavailable in this format';
      }
    }
  }

  customElements.define('voucher-picker', VoucherPicker);
})();
